import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactInputMask from 'react-input-mask';
import { ContainerStyled } from './style';
import MainLayout from 'components/main-layout/main-layout';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import DropdownSimple from 'components/UI/dropdown-simple/dropdown-simple';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import {
  faTrashAlt,
  faListUl,
  faPencilAlt,
  faDownload,
} from '@fortawesome/free-solid-svg-icons';
import indicacoesService from 'services/indicacao-especial-service/indicacao-especial-service';
import bolsasService from 'services/bolsas/bolsas-service';
import cursosService from 'services/cursos/cursos-service';
import { Bolsa } from 'models/bolsa';
import { Curso } from 'models/curso';
import { Indicacao } from 'models/indicacoes';
import VerDetalhesModal from 'modals/ver-detalhes-modal';
import EditarModal from 'modals/editar-modal';
import DeletarIndicacaoModal from '../../modals/deletar-indicacao-modal';
import FinalizarIndicacaoModal from '../../modals/finalizar-indicacao-modal';
import IndicarModal from '../../modals/indicar-modal';
import AlertModal from '../../modals/alert-modal/alert-modal';
import SortUtils from 'utils/sort-utils';
import { parse } from 'date-fns';
import { CadastroQualificado, Candidatos } from 'models/cadastro-qualificado';
import ExcelReader from 'components/UI/excel-reader/excel-reader';
import InputMoney from 'components/UI/input-money/input-money';
import { cpfMask, validaCPF } from 'utils/cpf-utils';
import { telMask } from 'utils/tel-utils';
import Helper from 'components/helperIcon';

function IndicacaoEspecial() {
  const [bolsas, setBolsas] = useState<Bolsa[]>([]);
  const [bolsa, setBolsa] = useState<Bolsa>();
  const [indicacaoDetalhes, setIndicacaoDetalhes] = useState<Indicacao>();
  const [indicacoes, setIndicacoes] = useState<Indicacao[]>([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [isIndicarModalOpen, setIsIndicarModalOpen] = useState(false);
  const [isFinalizarModalOpen, setIsFinalizarModalOpen] = useState(false);
  const [showList, setShowList] = useState(false);
  const [formIndicacao, setFormIndicacao] = useState<Indicacao>();
  const [formCadastroQualificado, setFormCadastroQualificado] = useState<
    CadastroQualificado
  >();
  const [cursos, setCursos] = useState<Curso[]>([]);
  const [curso, setCurso] = useState('');
  const [inscricao, setInscricao] = useState<CadastroQualificado>();
  const [indexEditarModalOpen, setIndexEditarModalOpen] = useState(-1);
  const [msgAlert, setMsgAlert] = useState('');
  const [cpf, setCpf] = useState('');
  const [nome, setNome] = useState('');
  const [bolsaCurso, setBolsaCurso] = useState('');
  const [data, setData] = useState<Date>();
  const [isValidFormatura, setIsValidFormatura] = useState(true);
  const [isValidPeriodoDebito, setIsValidPeriodoDebito] = useState(true);
  const [isValidValidade, setIsValidValidade] = useState(true);
  const [isValidCPF, setIsValidCPF] = useState(true);
  const isValid =
    formIndicacao?.nome &&
    formIndicacao?.cpf &&
    formIndicacao?.email &&
    formIndicacao?.telefone &&
    curso &&
    formIndicacao?.dataFormatura &&
    formIndicacao?.dataInicioRestituicao &&
    formIndicacao?.dataInicioValidade &&
    formIndicacao?.dataFimValidade &&
    formIndicacao?.parcelasRestituicao &&
    formIndicacao?.parcelas &&
    formIndicacao?.valorContrato &&
    isValidFormatura &&
    isValidValidade &&
    isValidCPF;
  const isValidCred =
    formCadastroQualificado?.nome && formCadastroQualificado?.cpf;

  const [label, setLabel] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [isExpress, setIsExpress] = useState(false);
  const [select, setSelect] = useState(0);

  const [uploadList, setUploadList] = useState<any[]>([]);

  useEffect(() => {
    bolsasService
      .getUsuarioIesBolsas()
      .then((resp) => {
        SortUtils.sortBolsas(resp);
        setBolsas(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const changeIndicacao = (campo, valor) => {
    setFormIndicacao({
      ...formIndicacao,
      [campo]: valor,
    } as Indicacao);
  };

  const changeCadastroQualificado = (campo, valor) => {
    setFormCadastroQualificado({
      ...formCadastroQualificado,
      [campo]: valor,
    } as CadastroQualificado);
  };

  const changeCpf = (target, standard = false) => {
    target = cpfMask(target);
    if (standard) {
      changeCadastroQualificado('cpf', target);
    } else {
      changeIndicacao('cpf', target);
    }
  };

  const changeTel = (target, standard = false) => {
    target = maskTel(target);
    if (standard) {
      changeCadastroQualificado('telefone', target);
    } else {
      changeIndicacao('telefone', target);
    }
  };

  const getCursos = () => {
    cursosService
      .getBolsasCurso(select)
      .then((resp) => {
        SortUtils.sortCursos(resp);
        setCursos(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onChange = (target) => {
    const ie = bolsas.find((value) => {
      return value.id + '' == target + '';
    });
    setBolsa(ie);
    setLabel(ie?.solucao + '');
    setSelect(target);
    if (isExpress) {
      getCursos();
    }
  };

  const onChangeRadio = (e) => {
    if (e.target.value === 'Express') {
      setIsExpress(true);
      getCursos();
    } else {
      setIsExpress(false);
    }
    setShowForm(true);
  };

  const maskTel = (value: any) => {
    let val = value
      .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d)/, '($1') // primeiro parentes
      .replace(/(\d{2})(\d)/, '$1) $2'); // segundo parenteses

    if (value.replace(/\D/g, '').length <= 10) {
      return val.replace(/(\d{4})(\d)/, '$1-$2');
    }
    return val.replace(/(\d{5})(\d)/, '$1-$2').replace(/(-\d{4}).+?$/, '$1');
  };

  const onClickDetalhes = (id) => {
    const indicacao = indicacoes.filter((value) => {
      return value.id == id;
    });
    setIndicacaoDetalhes(indicacao[0]);
    setModalOpen(true);
  };

  const onClickDelete = (id) => {
    const indicacao = indicacoes.filter((value) => {
      return value.id == id;
    });
    setIndicacaoDetalhes(indicacao[0]);
    setDeleteModalOpen(true);
  };

  const onDelete = (id) => {
    setDeleteModalOpen(false);
    setIndicacoes(
      indicacoes.filter((value) => {
        return value.id !== id;
      }),
    );
  };

  const onChangeParcela = (target) => {
    target = target.replace(/\D/g, '');
    changeIndicacao('parcelas', target);
  };

  const onChangeRestituicao = (target) => {
    target = target.replace(/\D/g, '');
    changeIndicacao('parcelasRestituicao', target);
  };

  const onBlurValidade = () => {
    if (formIndicacao?.dataInicioValidade && formIndicacao?.dataFimValidade) {
      let dataIni = parse(
        formIndicacao.dataInicioValidade + '',
        'dd/MM/yyyy',
        new Date(),
      );
      let dataFim = parse(
        formIndicacao.dataFimValidade + '',
        'dd/MM/yyyy',
        new Date(),
      );

      if (dataIni + '' == 'Invalid Date' || dataFim + '' == 'Invalid Date') {
        setIsValidValidade(false);
      } else if (dataIni > dataFim) {
        setIsValidValidade(false);
      } else {
        setIsValidValidade(true);
      }
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (formIndicacao) {
      const form: Indicacao = { ...formIndicacao };

      form.cpf = formIndicacao.cpf.replace(/[\.\-\.\s-]+/g, '');
      form.telefone = formIndicacao.telefone
        .replace('(', '')
        .replace(')', '')
        .replace('-', '')
        .replace(' ', '');

      form.dataInicioRestituicao = formIndicacao.dataInicioRestituicao;
      form.dataFormatura = formIndicacao.dataFormatura;
      form.dataInicioValidade = parse(
        formIndicacao.dataInicioValidade + '',
        'dd/MM/yyyy',
        new Date(),
      );
      form.dataFimValidade = parse(
        formIndicacao.dataFimValidade + '',
        'dd/MM/yyyy',
        new Date(),
      );

      form.parcelas = parseInt(formIndicacao.parcelas + '');
      form.valorContrato = parseFloat(formIndicacao.valorContrato + '');
      form.parcelasRestituicao = parseInt(
        formIndicacao.parcelasRestituicao + '',
      );
      form.periodoDebito = formIndicacao.periodoDebito;

      form.bolsaId = bolsa?.id;
      form.cursoId = parseInt(curso);

      if (
        isNaN(form.dataInicioValidade.getTime()) ||
        isNaN(form.dataFimValidade.getTime())
      ) {
        setIsIndicarModalOpen(false);

        setMsgAlert('Data inválida');
        setIsAlertModalOpen(true);

        return false;
      }

      indicacoesService
        .postIndicacaoEspecialExpress(form)
        .then((resp) => {
          if (resp?.id) {
            var i = {
              ...form,
              id: resp?.id,
            } as Indicacao;
            setIndicacoes([...indicacoes, resp]);
            setShowList(true);
          } else {
            setMsgAlert(resp.data.message);
            setIsAlertModalOpen(true);
          }
        })
        .catch((err) => {
          let indicacaoExpressExistente = err?.message.split(';');
          if (indicacaoExpressExistente.length === 4) {
            setBolsaCurso(indicacaoExpressExistente[0]);
            setCpf(indicacaoExpressExistente[1]);
            setNome(indicacaoExpressExistente[2]);
            setData(indicacaoExpressExistente[3]);
          }
          setMsgAlert(
            indicacaoExpressExistente.length !== 4
              ? err?.message
              : 'O CPF informado já possui solicitação de crédito ou uma indicação especial. Para mais informações, entre em contato com o time de atendimento da CSI - Central de Soluções',
          );
          setIsAlertModalOpen(true);
        })
        .then(() => setIsIndicarModalOpen(false));
    }
  };

  const onSubmitCred = (e) => {
    e.preventDefault();
    let valid = false;
    if (formCadastroQualificado) {
      formCadastroQualificado.bolsaId = bolsa?.id;
      formCadastroQualificado.ativo = true;
      setFormCadastroQualificado(formCadastroQualificado);

      if (formCadastroQualificado.nome && formCadastroQualificado.cpf) {
        formCadastroQualificado.cpf =
          '' + formCadastroQualificado.cpf.match(/\d+/g)?.join('');
        valid = true;
      }
      if (valid) {
        let candidatos = {
          candidatos: [
            {
              ...formCadastroQualificado,
            },
          ],
        } as Candidatos;
        indicacoesService
          .postIndicacaoEspecial(candidatos)
          .then((resp) => {
            if (resp.candidatos[0]?.id) {
              var i = {
                id: resp.candidatos[0]?.id,
                nome: formCadastroQualificado.nome,
                cpf: formCadastroQualificado.cpf,
                telefone: formCadastroQualificado?.telefone,
                email: formCadastroQualificado?.email,
              } as Indicacao;
              setFormCadastroQualificado({} as CadastroQualificado);
              setIndicacoes([...indicacoes, i]);
              setShowList(true);
            } else {
              setMsgAlert(resp.data.message);
              setIsAlertModalOpen(true);
            }
          })
          .catch((err) => {
            setMsgAlert(err.message);
            setIsAlertModalOpen(true);
          })
          .then(() => setIsIndicarModalOpen(false));
      }
    }
  };

  const onSubmitList = () => {
    let cadastros: CadastroQualificado[] = [];
    uploadList.forEach((candidato) => {
      let c: CadastroQualificado = {
        bolsaId: bolsa?.id,
        email: candidato.email,
        ativo: true,
        nome: candidato.nome,
        telefone: candidato.telefone,
        cpf: candidato.cpf.toString().replace(/\D/g, ''),
      };

      cadastros.push(c);
    });

    let candidatos = {
      candidatos: cadastros,
    } as Candidatos;

    indicacoesService
      .postIndicacaoEspecial(candidatos)
      .then((resp) => {
        setMsgAlert('Lista foi enviada com sucesso!');
        setIsAlertModalOpen(true);
        setUploadList([]);
      })
      .catch((err) => {
        setMsgAlert(err);
        setIsAlertModalOpen(true);
      })
      .then(() => setIsIndicarModalOpen(false));
  };

  const FinalizarIndicacao = (e) => {
    e.preventDefault();

    setIsFinalizarModalOpen(true);
  };

  const numberChanged = (money) => {
    changeIndicacao('valorContrato', money);
  };

  const onBlurFormatura = (e) => {
    let formatura = e.split('/');
    let ano = new Date().getFullYear();

    if (
      formatura.length != 2 ||
      formatura[1] > 2 ||
      formatura[1] < 1 ||
      formatura[0] < ano
    ) {
      setIsValidFormatura(false);
    } else {
      setIsValidFormatura(true);
    }
  };

  const onBlurPeriodoDebito = (e) => {
    let periodo = e.split('/');
    if (periodo.length != 2 || periodo[1] > 2 || periodo[1] < 1) {
      setIsValidPeriodoDebito(false);
    } else {
      setIsValidPeriodoDebito(true);
    }
  };

  const onBlurCPF = (e) => {
    if (e.length > 10) {
      if (validaCPF(e)) {
        setIsValidCPF(true);
      } else {
        setIsValidCPF(false);
      }
    }
  };

  const onClickDeleteUploadList = (key) => {
    const list = [...uploadList];
    list.splice(key, 1);
    setUploadList(list);
  };

  const onClickEditUploadList = (e, key) => {
    setInscricao(e);
    setIndexEditarModalOpen(key);
  };

  const onEdit = (candidato: CadastroQualificado, index: number) => {
    const tmpList = [...uploadList];
    tmpList[index] = { ...tmpList[index], ...candidato, valid: true };
    setUploadList(tmpList);
    setIndexEditarModalOpen(-1);
  };

  const onExcelUploaded = (list) => {
    const newList: any[] = [];

    for (let item of list) {
      const obj = {};

      for (let key of Object.keys(item)) {
        obj[key.toLocaleLowerCase()] = item[key];
      }

      newList.push(obj);
    }

    setUploadList(newList);
  };

  const returnTitle = (cursoId) => {
    const selectedCurso = cursos.find((c) => c.id === parseInt(cursoId));
    let cursoTitle = 'Selecione o Curso';
    if (selectedCurso && selectedCurso.nomeCampus === null) {
      cursoTitle = selectedCurso.curso;
    } else if (selectedCurso) {
      cursoTitle = selectedCurso.curso + ' - ' + selectedCurso.nomeCampus;
    }
    return cursoTitle;
  };

  return (
    <MainLayout>
      <ContainerStyled>
        <Container>
          <Row>
            <h2>Indicação especial</h2>
          </Row>

          <Link className="link-historico" to="/indicacao-especial-historico">
            <FontAwesomeIcon icon={faClock} /> Acessar histórico de indicação
          </Link>

          <Form onSubmit={(e) => e.preventDefault()}>
            <legend className="legend-small marginb-less">
              Selecione o convênio vinculado aos estudantes que serão indicados:
            </legend>
            <Form.Row>
              <Col md={6}>
                <DropdownSimple
                  className="select-padrao"
                  items={bolsas.map((bolsa) => ({
                    id: `${bolsa.id}`,
                    label: `${bolsa?.sigla} - ${bolsa?.solucao}`,
                  }))}
                  label={
                    bolsa
                      ? `${bolsa?.sigla} - ${bolsa?.solucao}`
                      : 'Selecione o convênio'
                  }
                  onItemClicked={(id) => onChange(id)}
                />
              </Col>
            </Form.Row>

            <div className="horizontal-bar">&nbsp;</div>

            {bolsa && (
              <>
                <legend>Indicar candidatos:</legend>
                <legend className="legend-small">
                  Informe a solução desejada para ofertar ao estudante:
                </legend>
                <div key={`custom-inline-radio`} className="radio-express">
                  <Form.Check
                    custom
                    inline
                    value="Express"
                    label={label + '/Express'}
                    type="radio"
                    name="tipo_candidato"
                    id={`custom-inline-radio-1`}
                    onChange={(e) => onChangeRadio(e)}
                  />
                  <Form.Check
                    custom
                    inline
                    value="Padrão"
                    label={label + '/Standard'}
                    type="radio"
                    name="tipo_candidato"
                    id={`custom-inline-radio-2`}
                    onChange={(e) => onChangeRadio(e)}
                  />
                </div>
              </>
            )}

            {showForm && isExpress && (
              <>
                <Form.Row>
                  <Col md={3}>
                    <Form.Label>
                      CPF
                      <Helper message={'Informe o CPF do(a) estudante'} />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder=""
                      value={formIndicacao?.cpf}
                      onChange={(e) => changeCpf(e.target.value)}
                      onBlur={(e) => onBlurCPF(e.target.value)}
                      isInvalid={!isValidCPF}
                    />
                    {!isValidCPF && <p className="error-msg">CPF inválido!</p>}
                  </Col>
                  <Col md={3}>
                    <Form.Label>
                      Nome
                      <Helper
                        message={'Insira o nome completo do(a) estudante'}
                      />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder=""
                      value={formIndicacao?.nome}
                      onChange={(e) => {
                        changeIndicacao('nome', e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Label>
                      Email
                      <Helper
                        message={
                          'Um e-mail válido é essencial para que possamos comunicar o(a) estudante. Só informe o e-mail se o(a) estudante autorizar.'
                        }
                      />
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder=""
                      value={formIndicacao?.email}
                      onChange={(e) => {
                        changeIndicacao('email', e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Label>
                      Telefone
                      <Helper
                        message={
                          'Informe telefone válido do(a) estudante com DDD, para que possamos comunicar eventuais alterações de status.'
                        }
                      />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder=""
                      value={formIndicacao?.telefone}
                      onChange={(e) => changeTel(e.target.value)}
                    />
                  </Col>
                </Form.Row>

                <Form.Row>
                  <Col md={3}>
                    <Form.Label></Form.Label>
                    <DropdownSimple
                      className="select-padrao-especial"
                      height="43px"
                      lineHeight="11px"
                      fontSize="11px"
                      items={cursos.map((curso) => ({
                        id: curso.id + '',
                        label:
                          curso.curso +
                          (curso.turno ? ' - ' + curso.turno : '') +
                          (curso.nomeCampus ? ' - ' + curso.nomeCampus : ''),
                      }))}
                      label={returnTitle(curso)}
                      onItemClicked={(id) => setCurso(id)}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>
                        Previsão de formatura
                        <Helper
                          message={
                            'O ano/semestre que o(a) estudante tem previsão para concluir o curso. Exemplo: 2020/2.'
                          }
                        />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Ano/Semestre"
                        value={formIndicacao?.dataFormatura}
                        as={ReactInputMask}
                        mask="9999/9"
                        isInvalid={!isValidFormatura}
                        onChange={(e) =>
                          changeIndicacao('dataFormatura', e.target.value)
                        }
                        onBlur={(e) => onBlurFormatura(e.target.value)}
                      />
                      <Form.Control.Feedback type="invalid">
                        Período inválido para o Ano/Semestre
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>
                        Período de contratação
                        <Helper
                          message={'Ano/semestre que o crédito será utilizado.'}
                        />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Ano/Semestre"
                        value={formIndicacao?.periodoDebito}
                        as={ReactInputMask}
                        mask="9999/9"
                        isInvalid={!isValidPeriodoDebito}
                        onChange={(e) =>
                          changeIndicacao('periodoDebito', e.target.value)
                        }
                        onBlur={(e) => onBlurPeriodoDebito(e.target.value)}
                      />
                      <Form.Control.Feedback type="invalid">
                        Período inválido para o Ano/Semestre
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Label>
                      Valor contratado
                      <Helper
                        message={
                          'Insira aqui o resultado da soma de todas as mensalidades que serão cobertas pelo crédito.'
                        }
                      />
                    </Form.Label>
                    <InputMoney
                      name="valorContratado"
                      onChange={numberChanged}
                    />
                  </Col>
                </Form.Row>

                <Form.Row>
                  <Col md={3}>
                    <Form.Label>
                      Parcelas cobertas
                      <Helper
                        message={'Quantas parcelas o crédito irá cobrir.'}
                      />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder=""
                      pattern="[0-9]*"
                      value={formIndicacao?.parcelas}
                      onChange={(e) => onChangeParcela(e.target.value)}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Label>
                      Parcelas a restituir
                      <Helper
                        message={
                          'Em quantas parcelas será feito o pagamento do valor contratado.'
                        }
                      />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder=""
                      value={formIndicacao?.parcelasRestituicao}
                      onChange={(e) => onChangeRestituicao(e.target.value)}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Label>
                      Início da restituição
                      <Helper
                        message={
                          'Mês e ano que o(a) estudante iniciará o pagamento dos valores à Fundacred.'
                        }
                      />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Mês/Ano"
                      as={ReactInputMask}
                      mask="99/9999"
                      value={formIndicacao?.dataInicioRestituicao}
                      onChange={(e) => {
                        changeIndicacao(
                          'dataInicioRestituicao',
                          e.target.value,
                        );
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <div className="campo-validade">
                      <Form.Label>
                        Validade da proposta
                        <Helper
                          message={'Qual o período de validade da proposta?'}
                        />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="De"
                        as={ReactInputMask}
                        mask="99/99/9999"
                        value={formIndicacao?.dataInicioValidade + ''}
                        isInvalid={!isValidValidade}
                        onBlur={() => onBlurValidade()}
                        onChange={(e) => {
                          changeIndicacao('dataInicioValidade', e.target.value);
                        }}
                      />
                    </div>
                    <div className="campo-validade">
                      <Form.Label>&nbsp;</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Até"
                        as={ReactInputMask}
                        mask="99/99/9999"
                        value={formIndicacao?.dataFimValidade + ''}
                        isInvalid={!isValidValidade}
                        onBlur={() => onBlurValidade()}
                        onChange={(e) => {
                          changeIndicacao('dataFimValidade', e.target.value);
                        }}
                      />
                    </div>
                    {!isValidValidade && (
                      <p className="error-msg">Campo de Validade inválido!</p>
                    )}
                  </Col>
                </Form.Row>

                <div className="horizontal-bar">&nbsp;</div>

                <div className="talign-right">
                  <Button
                    variant="primary"
                    type="button"
                    onClick={() => setIsIndicarModalOpen(true)}
                    disabled={!isValid}
                  >
                    Indicar candidato
                  </Button>
                </div>
              </>
            )}

            {showForm && bolsa && !isExpress && (
              <>
                <Form.Row>
                  <Col md={3}>
                    <Form.Label>
                      CPF
                      <Helper message={'Informe o CPF do(a) estudante'} />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder=""
                      value={formCadastroQualificado?.cpf}
                      onChange={(e) => changeCpf(e.target.value, true)}
                      onBlur={(e) => onBlurCPF(e.target.value)}
                      isInvalid={!isValidCPF}
                    />
                    {!isValidCPF && <p className="error-msg">CPF inválido!</p>}
                  </Col>
                  <Col md={3}>
                    <Form.Label>
                      Nome
                      <Helper
                        message={'Insira o nome completo do(a) estudante'}
                      />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder=""
                      value={formCadastroQualificado?.nome}
                      onChange={(e) => {
                        changeCadastroQualificado('nome', e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Label>
                      Email
                      <Helper
                        message={
                          'Um e-mail válido é essencial para que possamos comunicar o(a) estudante. Só informe o e-mail se o(a) estudante autorizar.'
                        }
                      />
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder=""
                      value={formCadastroQualificado?.email}
                      onChange={(e) => {
                        changeCadastroQualificado('email', e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Label>
                      Telefone
                      <Helper
                        message={
                          'Informe telefone válido do(a) estudante com DDD, para que possamos comunicar eventuais alterações de status.'
                        }
                      />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder=""
                      value={formCadastroQualificado?.telefone}
                      onChange={(e) => {
                        changeTel(e.target.value, true);
                      }}
                    />
                  </Col>
                </Form.Row>

                <Form.Row>
                  <ExcelReader onFileSelected={onExcelUploaded} />

                  <Button
                    href="https://s3-us-west-2.amazonaws.com/portal.fundacred.org.br/listaCandidatos.xlsx"
                    variant="primary"
                    className="btn-download"
                  >
                    <FontAwesomeIcon icon={faDownload} />
                    Baixar layout
                  </Button>
                </Form.Row>

                <div className="horizontal-bar">&nbsp;</div>

                <div className="talign-right">
                  <Button
                    variant="primary"
                    type="button"
                    onClick={() => setIsIndicarModalOpen(true)}
                    disabled={!isValidCred}
                  >
                    Indicar candidato
                  </Button>
                </div>
              </>
            )}
          </Form>

          {uploadList.length > 0 && (
            <>
              <div className="header-list">
                <Row>
                  <Col md={2}>CPF</Col>
                  <Col md={3}>Nome</Col>
                  <Col md={3}>Email</Col>
                  <Col md={4}>Telefone</Col>
                </Row>
              </div>

              <ListGroup className="upload-list">
                {uploadList?.map((e, key) => {
                  return (
                    <ListGroup.Item key={key}>
                      <Row>
                        <Col md={2}>
                          <p className={e.valid ? '' : 'invalid'}>
                            {cpfMask(e.cpf)}
                          </p>
                        </Col>
                        <Col md={3}>{e.nome}</Col>
                        <Col md={3}>{e.email}</Col>
                        <Col md={4}>
                          <Row>
                            <Col md={4}>
                              {e.telefone ? telMask(e.telefone + '') : ''}
                            </Col>
                            <Col md={7} className="talign-right">
                              <a onClick={() => onClickEditUploadList(e, key)}>
                                <FontAwesomeIcon icon={faPencilAlt} />
                                Editar
                              </a>{' '}
                              <a
                                href={void 0}
                                onClick={() => onClickDeleteUploadList(key)}
                              >
                                <FontAwesomeIcon icon={faTrashAlt} />
                                Apagar
                              </a>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
              <button
                className="btn btn-primary btn-enviar-lista"
                onClick={onSubmitList}
              >
                Enviar Lista
              </button>
            </>
          )}

          {showList && (
            <>
              <div className="horizontal-bar">&nbsp;</div>

              <legend>Lista de candidatos indicados</legend>

              <div className="header-list">
                <Row>
                  <Col md={2}>CPF</Col>
                  <Col md={3}>Nome</Col>
                  <Col md={3}>Email</Col>
                  <Col md={4}>Telefone</Col>
                </Row>
              </div>

              <ListGroup>
                {indicacoes?.map((e, key) => {
                  return (
                    <ListGroup.Item key={key}>
                      <Row>
                        <Col md={2}>{cpfMask(e.cpf)}</Col>
                        <Col md={3}>{e.nome}</Col>
                        <Col md={3}>{e.email}</Col>
                        <Col md={4}>
                          <Row>
                            <Col md={4}>
                              {e.telefone ? telMask(e.telefone) : ''}
                            </Col>
                            <Col md={7} className="talign-right">
                              <a
                                onClick={() => {
                                  onClickDetalhes(e.id);
                                }}
                              >
                                <FontAwesomeIcon icon={faListUl} />
                                Ver detalhes
                              </a>{' '}
                              <a
                                href={void 0}
                                onClick={() => onClickDelete(e.id)}
                              >
                                <FontAwesomeIcon icon={faTrashAlt} />
                                Apagar
                              </a>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>

              <div className="horizontal-bar">&nbsp;</div>

              <div className="talign-right">
                <Button
                  variant="primary"
                  onClick={(e) => FinalizarIndicacao(e)}
                >
                  Concluir
                </Button>
              </div>
            </>
          )}
        </Container>
      </ContainerStyled>
      <IndicarModal
        onSubmit={isExpress ? onSubmit : onSubmitCred}
        isOpen={isIndicarModalOpen}
        onClose={() => {
          setIsIndicarModalOpen(false);
        }}
      />
      <AlertModal
        isOpen={isAlertModalOpen}
        onClose={() => {
          setIsAlertModalOpen(false);
        }}
        message={msgAlert}
        cpf={cpf}
        bolsaCurso={bolsaCurso}
        data={data}
        nome={nome}
      />
      <FinalizarIndicacaoModal
        isOpen={isFinalizarModalOpen}
        onClose={() => {
          setIsFinalizarModalOpen(false);
        }}
      />
      <VerDetalhesModal
        isOpen={isModalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        indicacao={indicacaoDetalhes}
        bolsa={bolsa}
      />
      <EditarModal
        isOpen={indexEditarModalOpen >= 0}
        onClose={() => setIndexEditarModalOpen(-1)}
        indicacao={inscricao}
        onEdit={onEdit}
        index={indexEditarModalOpen}
      />
      <DeletarIndicacaoModal
        isOpen={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onDelete={onDelete}
        indicacao={indicacaoDetalhes}
        isExpress={isExpress}
      />
    </MainLayout>
  );
}

export default IndicacaoEspecial;
